import React, { useState } from "react"
import PropTypes from "prop-types"
import loadingGif from "../../images/loading.gif"
import {
  deliberationsContainer,
  deliberationsYearWrapper,
  deliberationsMonthList,
  deliberationsDocumentList,
  deliberationsLoadingWrapper,
  deliberationsLoadingSpinner,
  tabHidden,
} from "./deliberations.module.scss"
import { MonthFilter, YearFilter } from "./deliberations-styled.js"

const Deliberations = ({ deliberationsData }) => {
  const [selectedAnnee, setSelectedAnnee] = useState(null)
  const [selectedMonth, setSelectedMonth] = useState(null)
  return (
    <div>
      <div>
        {!deliberationsData && (
          <div className={deliberationsLoadingWrapper}>
            <img
              alt="loading gif"
              src={loadingGif}
              className={deliberationsLoadingSpinner}
            />
            <span>Chargement des données...</span>
          </div>
        )}
        {deliberationsData &&
          (!Object.keys(deliberationsData).length ? (
            <span>Aucun acte présent</span>
          ) : (
            <>
              <div
                className={deliberationsYearWrapper}
                role={"tablist"}
                aria-label={"Liste des années"}
              >
                {Object.keys(deliberationsData).map((annee, index) => (
                  <YearFilter
                    key={index}
                    onClick={() => {
                      setSelectedAnnee(annee)
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        setSelectedAnnee(annee)
                      }
                    }}
                    active={annee === selectedAnnee}
                    className="btn"
                    id={"tab-" + annee}
                    role={"tab"}
                    aria-selected={annee === selectedAnnee}
                    aria-controls={"tabpanel-" + annee}
                    tabIndex={0}
                  >
                    {parseInt(annee)}
                  </YearFilter>
                ))}
              </div>

              {!selectedAnnee ? (
                <p>Veuillez sélectionner une année</p>
              ) : (
                !selectedMonth && <p>Veuillez sélectionner un mois</p>
              )}

              {Object.keys(deliberationsData).map((annee, index) => {
                const classesYears = `${deliberationsContainer} ${
                  selectedAnnee !== annee ? tabHidden : ""
                }`
                return (
                  <div
                    key={index}
                    className={classesYears}
                    role="tabpanel"
                    id={"tabpanel-" + annee}
                    aria-labelledby={"tab-" + annee}
                  >
                    {deliberationsData[annee] && (
                      <>
                        <div
                          className={deliberationsMonthList}
                          role={"tablist"}
                          aria-label={"Liste des mois"}
                        >
                          {Object.keys(deliberationsData[annee])
                            .sort((monthA, monthB) => monthB - monthA)
                            .map((mois, indexMois) => {
                              const date = new Date()
                              date.setMonth(mois - 1)
                              const labelMois = date.toLocaleString("fr-FR", {
                                month: "long",
                              })
                              return (
                                <MonthFilter
                                  key={indexMois}
                                  onClick={() => setSelectedMonth(mois)}
                                  active={mois === selectedMonth}
                                  id={"tab-" + mois}
                                  role="tab"
                                  aria-selected={mois === selectedMonth}
                                  aria-controls={"tabpanel-" + mois}
                                  onKeyDown={(event) => {
                                    if (event.key === "Enter") {
                                      setSelectedMonth(mois)
                                    }
                                  }}
                                  tabIndex={0}
                                >
                                  {labelMois}
                                </MonthFilter>
                              )
                            })}
                        </div>
                        {Object.keys(deliberationsData[annee]).map(
                          (month, indexContent) => {
                            const classesMonths = `${deliberationsDocumentList} ${
                              month !== selectedMonth ? tabHidden : ""
                            }`
                            return (
                              <div
                                key={indexContent}
                                className={classesMonths}
                                role="tabpanel"
                                id={"tabpanel-" + month}
                                aria-labelledby={"tab-" + month}
                              >
                                <table>
                                  {selectedMonth && (
                                    <tr>
                                      <th>Document</th>
                                      <th>Date de publication</th>
                                    </tr>
                                  )}
                                  {Object.keys(deliberationsData[annee]).map(
                                    (mois, indexMois) =>
                                      selectedMonth === mois &&
                                      Object.keys(
                                        deliberationsData[annee][mois]
                                      ).map((jourImport) =>
                                        Object.keys(
                                          deliberationsData[annee][mois][
                                            jourImport
                                          ]
                                        ).map(
                                          (jourDocument, indexJourDocument) =>
                                            deliberationsData[annee][mois][
                                              jourImport
                                            ][jourDocument].map(
                                              (document, indexDocument) => {
                                                const dateImport =
                                                  document.dateImport &&
                                                  document.dateImport !== "--"
                                                    ? new Date(
                                                        document.dateImport
                                                      )
                                                    : new Date(
                                                        document.dateDocument
                                                      )

                                                const name =
                                                  document.name ??
                                                  document.path.split("/").pop()

                                                return (
                                                  <tr key={indexJourDocument}>
                                                    <td>
                                                      <a
                                                        href={
                                                          process.env
                                                            .GATSBYSIDE_DRUPAL_URL +
                                                          document.path
                                                        }
                                                        target="_blank"
                                                        rel="noreferrer"
                                                      >
                                                        {name}
                                                      </a>
                                                    </td>
                                                    <td>
                                                      {dateImport.toString() !==
                                                      "Invalid Date"
                                                        ? dateImport.toLocaleString(
                                                            "fr-FR",
                                                            {
                                                              year: "numeric",
                                                              month: "long",
                                                              day: "numeric",
                                                            }
                                                          )
                                                        : "Pas de date"}
                                                    </td>
                                                  </tr>
                                                )
                                              }
                                            )
                                        )
                                      )
                                  )}
                                </table>
                              </div>
                            )
                          }
                        )}
                      </>
                    )}
                  </div>
                )
              })}
            </>
          ))}
      </div>
    </div>
  )
}

Deliberations.propTypes = {
  deliberationsData: PropTypes.object,
}

export default Deliberations
